import ouiBase from '@goldwasserexchange/oui';
import { useBondSameIssuerFieldApiBySAccId } from '../api';

export const useBondSameIssuerSAccIntRate = () => {
  const sAccId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const response = useBondSameIssuerFieldApiBySAccId({
    sAccId,
    field: 'S_ACC.INT_RATE',
  });
  return response;
};
